import { render, staticRenderFns } from "./PaginationNavPill.vue?vue&type=template&id=73eaf6b2&"
import script from "./PaginationNavPill.vue?vue&type=script&lang=js&"
export * from "./PaginationNavPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports